import React, { Component } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";



class LaborWeeklyInputs extends Component {
  render() {
    const {
      projLaborList,
      projContractorList,
      lw_weekOf,
      isSaturday,
      lw_selectedContractor,
      lw_selectedLabors,
      handleChange_lw_weekOf,
      handleChange_lw_contractor,
      handleChange_lw_labors,
      disabled,
    } = this.props;
    return (
      <div className="card mx-0 mb-2">
        <div className="card-body pb-2">
          <h5 className="mb-3 text-muted">Labor Weekly Report</h5>
          <div className="form-row form-group">
            <label className="col-sm-3 col-form-label my-auto">For Week Ending:</label>
            <div className="col-sm-4">
              <DatePicker
                customInput={<CustomDatePickerInput />}
                name="lw_weekOf"
                id="lw_weekOf"
                selected={lw_weekOf}
                onChange={handleChange_lw_weekOf}
                filterDate={isSaturday}
                placeholderText="Pick a Week..."
                disabled={disabled}
              />
            </div>
          </div>
          {/* <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="contractors" className="col-form-label">
                For Contractor:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="contractorId"
                id="contractorId"
                value={lw_selectedContractor}
                options={
                  projContractorList &&
                  projContractorList.map((c) => ({
                    value: c.contractorId,
                    label: c.name,
                  }))
                }
                onChange={(value) => handleChange_lw_contractor(value)}
                placeholder="(Select a Contractor)"
                isSearchable={false}
                isDisabled={disabled}
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="labors" className="col-form-label">
                Labors:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="laborIds"
                id="laborIds"
                value={lw_selectedLabors}
                options={
                  projLaborList &&
                  projLaborList.map((l) => ({
                    value: l.laborId,
                    label: l.fullName,
                  }))
                }
                onChange={(value) => handleChange_lw_labors(value)}
                placeholder="(Select or Key-in Labors)"
                isMulti
                isSearchable
                isDisabled={disabled}
              />
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default LaborWeeklyInputs;
